// Parent portal auth storage. JWT expires after 7 days server-side.
const KEY = "zca_portal_token";
const KEY_USER = "zca_portal_user";

export function savePortalAuth({ token, enrollment_id, parent_name, email }) {
  localStorage.setItem(KEY, token);
  localStorage.setItem(
    KEY_USER,
    JSON.stringify({ enrollment_id, parent_name, email })
  );
}

export function getPortalToken() {
  return localStorage.getItem(KEY) || "";
}

export function getPortalUser() {
  try {
    return JSON.parse(localStorage.getItem(KEY_USER) || "null");
  } catch {
    return null;
  }
}

export function clearPortalAuth() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(KEY_USER);
}
